import { LuMenu } from "react-icons/lu";
import {
  Drawer,
  IconButton,
  type IconButtonProps,
  Portal,
} from "@chakra-ui/react";

import { SideBar } from ".";

export const SidebarDrawerOpener: React.FC<Partial<IconButtonProps>> = (
  props,
) => (
  <Drawer.Root placement="start">
    <Drawer.Trigger>
      <IconButton {...props}>
        <LuMenu />
      </IconButton>
    </Drawer.Trigger>
    <Portal>
      <Drawer.Backdrop />

      <Drawer.Positioner>
        <Drawer.Content px={0} py={4}>
          <Drawer.CloseTrigger />
          <Drawer.Body p={0} overflowY="auto">
            <SideBar />
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Portal>
  </Drawer.Root>
);
